import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ProvidersService {

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient) { }

  getProviders() {
    let config = {
        headers: new HttpHeaders({'Content-Type':'application/json'})
      };

      return this.http.get('/TrackingProviders/getProviders', config);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/providers/provider.service.ts